<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12 md6 offset-md3 lg4 offset-lg4 xl2 offset-xl5)
        v-toolbar(flat dense color="secondary")
          v-icon(class="white--text") account_circle
          v-toolbar-title(class="white--text") {{$t('_account.user_select')}}

        v-card.pb-2
          v-card-text
            v-btn.rem16(
              v-for="(member, index) in list"
              :key="index"
              color="primary"
              block
              large
              style="height: 60px"
              @click="pseudoLogin(member)"
            )
              span {{member.name}}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  data () {
    return {
      list: []
    }
  },
  created () {
    if (process.env.AUTH_STORATEGY !== 'pseudo') {
      this.$router.push({ name: `${process.env.AUTH_STORATEGY}_signin` })
      return true
    }
    if (this.isAuthenticated) {
      this.$router.push({ name: 'dispatch' })
      return true
    }
    this.$ajax
      .get(process.env.AUTH_PSEUDO_USERS_URI, {
        loading: false
      })
      .then(response => {
        this.list = response.data
      })
  },
  beforeDestroy () {},
  computed: {
    ...mapGetters('common/pseudo', ['isAuthenticated'])
  },
  methods: {
    ...mapActions('common/pseudo', ['signIn']),
    pseudoLogin (member) {
      this.signIn(
        Object.assign({}, member, {
          uuid: member.id
        })
      )
        .then(() => {
          let referrer = sessionStorage.getItem('callback_referrer') || '/'
          sessionStorage.removeItem('callback_referrer')
          this.$router.push({ name: 'dispatch', query: { referrer: referrer } })
        })
        .catch(error => {
          console.log(error)
          const tKey = error.error || '_account.unknown_error'
          this.$toastr.error(this.$t(tKey))
          this.$router.push({ name: 'account_sorry' })
        })
    }
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/common/pages/Pseudo/SignIn/index.vue